import './index_mWeb.css';
import { useDispatch } from 'react-redux';
import { FlatListWrapper, View } from '../../../component';
import useGame from '../../../utilities/hooks/game';
import { ContestShare } from '../../component';
import ContestCardMWeb from '../../component/contest_card/index_mWeb';
import ContestListHeaderMWeb from '../../component/contest_list_header/index_mWeb';
import { getRouteObjByGame } from '../../../utilities/helper';
import FlatList from 'flatlist-react';
import { useLink } from 'react-router-stack';
import Button from '@mui/material/Button/Button';
import ContestSortingHeaderMWeb from '../../component/contest_sorting_header/index_mWeb';
import ContestFilterMWeb from '../../component/contest_filter/index_mWeb';
import React from 'react';

const ContestListTabMWeb = ({
  onPressFilter,
  onPressEntryFee,
  onPressPrizePool,
  onPressSpots,
  onPressWinner,
  onPressCard,
  onPressShare,
  contestCategoryList,
  matchStatus,
  gameState,
  totalTeamsCount,
  matchItem,
  matchDelayed,
  gameType,
  onApplyFilter,
  onClearFilter,
  contestFilterVisible,
  onPressFilterDismiss,
  contestLink,
  contestTitle,
  contestShare,
  onPressShareModalDismiss,
  showAllContest
}: any) => {
  const navigate = useLink();
  const { fantasyMatchClick } = useGame();
  const dispatch = useDispatch();

  const renderItem = (item: any) => {
    return (
      <>
        <View key={item.header.id}>
          <ContestListHeaderMWeb
            contestCategory={item.header}
            key={item.header._id}
            contestCount={item.header.contestCount}
            onPressViewAll={showAllContest}
          />
        </View>
        {item.data.map((item: any) => (
          <ContestCardMWeb
            key={item._id}
            contest={item}
            onPressCard={() => onPressCard(item)}
            onPressShare={() => onPressShare()}
            matchStatus={matchStatus}
            gameState={gameState}
            totalTeamsCount={totalTeamsCount}
            matchItem={matchItem}
            screenName={'CONTEST_LIST'}
            matchDelayed={matchDelayed}
            gameType={gameType}
          />
        ))}
      </>
    );
  };

  const createTeamButton: any = {
    color: '#252830',
    textTransform: 'none',
    backgroundImage: 'linear-gradient(to bottom, #f6c53f, #ffc300)',
    border: `solid 1px #fff079`,
    width: '150px'
  };
  const onPressCreateTeam = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          isFromCreateTeamButton: true,
          selectedTeamPlayers: [],
          teamData: {
            teamNumber: totalTeamsCount + 1
          },
          isEdit: false,
          isClone: false
        }
      })
    );
    navigate.push(getRouteObjByGame(gameType)['create_team']);
  };
  return (
    <React.Fragment>
      <View style={{ overflowY: 'hidden', position: 'relative' }}>
        <ContestSortingHeaderMWeb
          onPressFilter={onPressFilter}
          onPressEntryFee={onPressEntryFee}
          onPressPrizePool={onPressPrizePool}
          onPressSpots={onPressSpots}
          onPressWinner={onPressWinner}
        />

        <FlatListWrapper
          className={'flat-list-padding'}
          style={{
            paddingBottom: '170px'
          }}>
          <FlatList list={contestCategoryList} renderItem={renderItem} renderOnScroll />
        </FlatListWrapper>

        <ContestFilterMWeb
          onApplyFilter={onApplyFilter}
          onClearFilter={onClearFilter}
          visible={contestFilterVisible}
          onPressDismiss={onPressFilterDismiss}
        />
        <ContestShare
          link={contestLink}
          contestTitle={contestTitle}
          visible={contestShare}
          onPressDismiss={onPressShareModalDismiss}
        />
      </View>
      {totalTeamsCount < 11 && (
        <View className="contest-list-create-btn-wrapper_mWeb">
          <Button
            onClick={onPressCreateTeam}
            style={createTeamButton}
            className={'contest-list-create-btn_mWeb'}>
            {'Create Team'}
          </Button>
        </View>
      )}
    </React.Fragment>
  );
};

export default ContestListTabMWeb;
